import { UserAuditLogEntry } from 'apis/auditLogs';

import { UserLink } from '../activityTypes/userLink/userLink';
import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type ContactMergedIntoProps = {
  entry: UserAuditLogEntry<'CONTACT_MERGED_INTO'>;
};

/** Marker on a merged-away contact's timeline: it was merged into another contact. */
export const ContactMergedInto = ({
  entry,
}: ContactMergedIntoProps): JSX.Element => (
  <UserActivityCard
    entry={entry}
    icon="combine"
    color={statusColors.info}
    title="Merged into"
    titleSuffix={
      <UserLink
        userId={entry.target.id}
        onClick={(event) => event.stopPropagation()}
      >
        {entry.target.name ?? entry.target.id}
      </UserLink>
    }
  />
);
